// extracted by mini-css-extract-plugin
export default {"root":"root--MQaI8","youngCouples":"youngCouples--sxwFH","luxuryApartments":"luxuryApartments--J2XDw","investment":"investment--slDJs","app":"app--FCd84"};